<template>
  <v-row class="table-controls mb-1">
    <v-col cols="12">
      <div v-if='$getRight("locationCreate") && $getRight("locationView")'>
        <v-btn
          v-if='getUsed("locations") < getLimit("locations")'
          color='transparent'
          depressed
          @click="$router.push({ name: 'CreateLocation', params: { id: locationId } })"
          class='px-2'
        >
          <v-img max-height="14" max-width="14" class="mr-2" src="@/assets/icons/svg/plus.svg" />
          <span class="text-subtitle-2 font-weight-bold">Add Location</span>
        </v-btn>
        <v-btn
          v-else
          color='transparent'
          depressed
          @click='showUpgradeSubscriptionPlanPopup'
          class='px-2'
        >
          <v-img max-height="14" max-width="14" class="mr-2" src="@/assets/icons/svg/plus.svg" />
          <span class="text-subtitle-2 font-weight-bold">Add Location</span>
        </v-btn>
      </div>
      <div>
        <v-btn
          color='transparent'
          depressed
          @click="$router.push({ name: 'CreateLocation', params: { id: locationId } })"
          class='px-2'
        >
          <v-img max-height="14" max-width="14" class="mr-2" src="@/assets/icons/svg/plus.svg" />
          <span class="text-subtitle-2 font-weight-bold">Add Location</span>
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getLimitMixin } from '@/mixins/getLimit'
export default {
  components: {
  },
  props: {
    locationId: {
      required: true
    }
  },
  data() {
    return {
    }
  },
  mixins: [getLimitMixin],
  computed: {
    ...mapGetters('warehouses', ['getActiveWarehouse'])
  },
  methods: {
    ...mapActions(['showUpgradeSubscriptionPlanPopup'])
  }
}
</script>

<style scoped lang="scss">

</style>
